var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("search",null,{"currentProductType":_vm.currentProductType,"updateProductType":_vm.updateProductType,"pageLink":_vm.settingsProperty.pageLink}),_vm._t("content-area")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }